import JSZip from "jszip";
import axios from "axios";
import { saveAs } from "file-saver";
import { mapActions } from 'vuex';
import { Const } from './provider/candle-history/lib/const.cls';
import * as Types from '../../types';
import { fxView } from './lib/fxView.cls';
import * as fxViewStoreExtensions from './provider/candle-history';
const state = Object.assign({}, fxViewStoreExtensions.stateExt);
const actions = Object.assign({}, fxViewStoreExtensions.actionsExt);
const mutations = Object.assign({}, fxViewStoreExtensions.mutationsExt);
const getters = Object.assign({}, fxViewStoreExtensions.gettersExt);
const fxViewStore = {
    state,
    actions,
    mutations,
    getters
};
let _store;
let intervalValue = null;
const zip = new JSZip();
export const fxViewMixins = {
    created() {
        const _store = this.$store;
        if (!(_store && _store.state && _store.state[fxView.STORE_MODULE_NAME])) {
            try {
                this.$store.registerModule(fxView.STORE_MODULE_NAME, fxViewStore);
            }
            catch (error) { }
        }
    },
    methods: Object.assign(Object.assign({}, mapActions({
        _runGetClientData: Const.RUN_GET_CLIENT_DATA,
        //===================static variable fetch from database============================
        _runGetCountriesList: Const.RUN_GET_COUNTRIES_LIST,
        _runGetCitiesList: Const.RUN_GET_CITIES_LIST,
        // upload document
        _runUploadReceipt: Const.RUN_UPLOAD_RECEIPT,
        //coupon
        _runGetCouponList: Const.RUN_GET_COUPON_LIST,
        _runCreateCoupon: Const.RUN_CREATE_COUPON,
        _runGetDashboardData: Const.RUN_GET_DASHBOARD_DATA,
        _runGetDashboardOtherData: Const.RUN_GET_DASHBOARD_OTHER_DATA,
        _runGetTotalClient: Const.RUN_GET_TOTAL_CLIENT,
        //manage-group
        _runGetManageGroupList: Const.RUN_GET_MANAGE_GROUP_LIST,
        _runAddEditAdminMangeGroup: Const.RUN_ADD_EDIT_ADMIN_MANAGE_GROUP_DATA,
        //task
        _runGetTaskList: Const.RUN_GET_TASK_LIST,
        _runAddTask: Const.RUN_ADD_TASK,
        _runTaskUpdateStatus: Const.RUN_TASK_UPDATE_STATUS,
        //admin
        _runGetAdminList: Const.RUN_GET_ADMIN_LIST,
        _runGetAdminDetail: Const.RUN_GET_ADMIN_DETAIL,
        _runAddAdmin: Const.RUN_ADD_ADMIN,
        _runUpdateAdminDetail: Const.RUN_UPDATE_ADMIN_DETAIL,
        _runGetNotificationList: Const.RUN_GET_NOTIFICATION_LIST,
        _runGetNotificationOLD: Const.RUN_GET_NOTIFICATION_OLD,
        //email
        _runEmailSettingList: Const.RUN_EMAIL_SETTING_LIST,
        _runAddEmailSetting: Const.RUN_ADD_EMAIL_SETTING,
        //client
        _runCloseAccount: Const.RUN_CLOSE_ACCOUNT,
        _runGetClientReport: Const.RUN_GET_CLIENT_REPORT,
        _runAllowForIpv: Const.RUN_ALLOW_FOR_IPV,
        _runGetUserList: Const.RUN_GET_USER_LIST,
        _runGetLogsList: Const.RUN_GET_LOGS_LIST,
        _runGetLogsView: Const.RUN_GET_LOGS_VIEW,
        _runGetLogsDetail: Const.RUN_GET_LOGS_DETAIL,
        _runGetUserView: Const.RUN_GET_USER_VIEW,
        _runEditPaymentMethods: Const.RUN_EDIT_PAYMENT_METHODS,
        _runDisablePaymentMethod: Const.RUN_DISABLE_PAYMET_METHOD,
        _runUpdateClientDetail: Const.RUN_UPDATE_CLIENT_DETAIL,
        _runResetPassword: Const.RUN_RESET_PASSWORD,
        _runUserCount: Const.RUN_USER_COUNT,
        _runUserNotification: Const.RUN_USER_NOTIFICATIONS,
        _runAddWithdrawal: Const.RUN_ADD_WITHDRAWAL,
        _runAddTicket: Const.RUN_ADD_TICKET,
        _runGetInternalNotes: Const.RUN_GET_INTERNAL_NOTES,
        _runGetAllInternalNotes: Const.RUN_GET_ALL_INTERNAL_NOTES,
        _runCreateActivity: Const.RUN_CREATE_ACTIVITY,
        _runGetActivity: Const.RUN_GET_ACTIVITY,
        _runAddInternalNotes: Const.RUN_ADD_INTERNAL_NOTES,
        _runVerifyAccount: Const.RUN_VERIFY_ACCOUNT,
        _runGetRiskMetrix: Const.RUN_GET_RISK_METRIX,
        _runCreateTradingAccount: Const.RUN_CREATE_TRADING_ACCOUNT,
        _rundisable2fa: Const.RUN_DISABLE2FA,
        _runSendEmailUser: Const.RUN_SEND_EMAIL_USER,
        _runRemoveUser: Const.RUN_REMOVE_USER,
        //request Access
        _runRequestOtp: Const.RUN_REQUEST_OTP,
        _runVerifyOtp: Const.RUN_VERIFY_OTP,
        _runIbRequestOtp: Const.RUN_IB_REQUEST_OTP,
        _runIbVerifyOtp: Const.RUN_IB_VERIFY_OTP,
        //faq
        _runCreateCategory: Const.RUN_CREATE_CATEGORY,
        _runCreateArticle: Const.RUN_CREATE_ARTICLE,
        _runGetCatList: Const.RUN_GET_CAT_LIST,
        _runGetArticleList: Const.RUN_GET_ARTICLE_LIST,
        _runGetCatDetail: Const.RUN_GET_CAT_DETAIL,
        _runGetArticleDetail: Const.RUN_GET_ARTICLE_DETAIL,
        _rundeleteArticle: Const.RUN_DELETE_ARTICLE,
        _rundeleteCategory: Const.RUN_DELETE_CATEGORY,
        //deposit
        _runCreateDeposit: Const.RUN_CREATE_DEPOSIT,
        _runGetDepositList: Const.RUN_GET_DEPOSIT_LIST,
        _runGetDepositView: Const.RUN_GET_DEPOSIT_VIEW,
        _runEditDepositDetails: Const.RUN_EDIT_DEPOSIT_DETAILS,
        _runGetTransactionStatus: Const.RUN_GET_DEPOSIT_TRANSACTION_STATUS,
        _runDepositUpload: Const.RUN_DEPOSIT_UPLOAD,
        _runUpdateDepositSuspense: Const.RUN_DEPOSIT_UPDATE_SUSPENSE,
        _runDepositAssign: Const.RUN_DEPOSIT_ASSIGN,
        _runDownloadDepositFile: Const.RUN_DOWNLOAD_DEPOSIT_FILE,
        _runDownloadWithdrawalFile: Const.RUN_DOWNLOAD_WITHDRAWAL_FILE,
        //bonus
        _runGetBonusList: Const.RUN_GET_BONUS_LIST,
        _runGetBonusView: Const.RUN_GET_BONUS_VIEW,
        _runGetBonusDetail: Const.RUN_GET_BONUS_DETAIL,
        _runAddBonus: Const.RUN_ADD_BONUS,
        //ticket
        _runGetTicketList: Const.RUN_GET_TICKET_LIST,
        _runGetTicketView: Const.RUN_GET_TICKET_VIEW,
        _runTicketReply: Const.RUN_TICKET_REPLY,
        _runTicketApprove: Const.RUN_TICKET_APPROVE,
        _runTicketDocApproveReject: Const.RUN_TICKET_DOC_APPROVE_REJECT,
        _runTicketTransfer: Const.RUN_TICKET_TRANSFER,
        _runCloseTicket: Const.RUN_CLOSE_TICKET,
        _runTicketApproveMultiple: Const.RUN_TICKET_APPROVE_MULTIPLE,
        _runEscalateTicket: Const.RUN_ESCALTE_TICKET,
        _runGetGroupAdminName: Const.RUN_GET_GROUP_ADMIN_NAME,
        _runTicketCheckOtp: Const.RUN_TICKET_CHECK_OTP,
        _runTicketResendOtp: Const.RUN_TICKET_RESEND_OTP,
        _runTicketRequestOtp: Const.RUN_TICKET_REQUEST_OTP,
        //withdrawal
        _runGetWithdrawalList: Const.RUN_GET_WITHDRAWAL_LIST,
        _runGetWithdrawalListMaker: Const.RUN_GET_WITHDRAWAL_LIST_MAKER,
        _runSendWithData: Const.RUN_SEND_WITH_DATA,
        _runGetWithdrawalView: Const.RUN_GET_WITHDRAWAL_VIEW,
        _runWithdrawalMethods: Const.RUN_WITHDRAWAL_METHODS,
        _runEditWithdrawalDetails: Const.RUN_EDIT_WITHDRAWAL_DETAILS,
        _runGetAccountDetails: Const.RUN_GET_ACCOUNT_DETAIL,
        _runDownloadFiles: Const.RUN_DOWNLOAD_FILES,
        _runTicketReasonList: Const.RUN_TICKET_REASON_LIST,
        _runGetTicketReasonList: Const.RUN_GET_TICKET_REASON_LIST,
        //trading
        _runGetTradingList: Const.RUN_GET_TRADING_LIST,
        _runGetTradingView: Const.RUN_GET_TRADING_VIEW,
        _runEditTradingDetails: Const.RUN_EDIT_TRADING_DETAILS,
        _runChangeLeverage: Const.RUN_CHANGE_LEVERAGE,
        // _runTradingEnableDisable                		:   			Const.RUN_TRADING_ENABLE_DISABLE,
        _runDeleteTradingAccount: Const.RUN_DELETE_TRADING_ACCOUNT,
        _runDisableTradingAccount: Const.RUN_DISABLE_TRADING_ACCOUNT,
        //changepassword
        _runChangePassword: Const.RUN_CHANGE_PASSWORD,
        _runGetChartData: Const.RUN_GET_CHART_DATA,
        _runGetRmList: Const.RUN_GET_RM_LIST,
        _runAddWebinar: Const.RUN_ADD_WEBINAR,
        _runGetTutCourse: Const.RUN_GET_TUT_COURSE,
        _runCreateTutCourse: Const.RUN_CREATE_TUT_COURSE,
        _runGetTutCat: Const.RUN_GET_TUT_CAT,
        _runCreateTutCat: Const.RUN_CREATE_TUT_CAT,
        _runGetTutorialList: Const.RUN_GET_TUTORIAL_LIST,
        _runCreateTutorial: Const.RUN_CREATE_TUTORIAL,
        _runAddCategory: Const.RUN_ADD_CATEGORY,
        _runAddPost: Const.RUN_ADD_POST,
        _runGetCategoryList: Const.RUN_GET_CATEGORY_LIST,
        _runGetPostList: Const.RUN_GET_POST_LIST,
        _runuploadDocument: Const.RUN_UPLOAD_DOCUMENT,
        _runuploadDocumentpip: Const.RUN_UPLOAD_DOCUMENT_PIP,
        _runGetSubscriptionList: Const.RUN_GET_SUBSCRIPTION_LIST,
        _runGetSubscriptionDetail: Const.RUN_GET_SUBSCRIPTION_DETAIL,
        _runUserSubscriptionEnd: Const.RUN_USER_SUBSCRIPTION_END,
        _runUserSubscriptionUpdateAccount: Const.RUN_USER_SUBSCRIPTION_UPDATE_ACCOUNT,
        _runGetVpsList: Const.RUN_GET_VPS_LIST,
        _runUserOtherDetails: Const.RUN_USER_OTHER_DETAILS,
        //loyality
        _runGetloyalityTransactionList: Const.RUN_GET_LOYALITY_TRANSACTION_LIST,
        _runGetloyalityCardList: Const.RUN_GET_LOYALITY_CARD_LIST,
        _runBulkUpdateRmAccuracy: Const.RUN_BULK_UPDATE_RM_ACCURACY,
        _runGetCommissionTradingReportList: Const.RUN_GET_COMMISSION_TRADING_REPORT_LIST,
        _runGetCommissionReportList: Const.RUN_GET_COMMISSION_REPORT_LIST,
        _runGetCommissionWithdrawalList: Const.RUN_GET_COMMISSION_WITHDRAWAL_LIST,
        _runGetCommissionReportDetail: Const.RUN_GET_COMMISSION_REPORT_DETAIL,
        _runUploadsList: Const.RUN_GET_UPLOADS_LIST,
        _runUpdateLoyaltyPoints: Const.RUN_UPDATE_LOYALTY_POINTS,
        _runGetClientLeads: Const.RUN_GET_CLIENT_LEADS,
        _runReassignLeads: Const.RUN_REASSIGN_LEADS,
        _runGetAdminDepositMethods: Const.RUN_GET_ADMIN_DEPOSIT_METHODS,
        _runadminAddDepositMethods: Const.RUN_ADMIN_ADD_DEPOSIT_METHODS,
        _runadminChangeWithdrawalMethod: Const.RUN_ADMIN_CHANGE_WITHDRAWAL_METHOD,
        _runadminChangeDepositMethod: Const.RUN_ADMIN_CHANGE_DEPOSIT_METHOD,
        _runLoyalityPointCount: Const.RUN_LOYALITY_POINT_COUNT,
        _runChangeAcccountLimit: Const.RUN_CHANGE_ACCOUNT_LIMIT,
        _runChangeAcccountType: Const.RUN_CHANGE_ACCOUNT_TYPE,
        _runUpdateWithdrawalDetails: Const.RUN_UPDATE_WITHDRAWAL_DETAILS,
        _runUpdateDepositDetails: Const.RUN_UPDATE_DEPOSIT_DETAILS,
        _runLockTransection: Const.RUN_LOCK_TRANSECTION,
        _runAddWithdrawalComment: Const.RUN_UPDATE_WITHDRAWAL_COMMENT,
        _runAddDepositComment: Const.RUN_UPDATE_DEPOSIT_COMMENT,
        //getusertoken
        _runGetClientToken: Const.RUN_GET_CLIENT_TOKEN,
        _runGetIBPortalToken: Const.RUN_GET_IB_LOGIN_TOKEN,
        _runSetMarketHolidays: Const.RUN_SET_MARKET_HOLIDAYS,
        _runGetMarketHolidays: Const.GET_MARKET_HOLIDAYS,
        _runUPloadHelp2payPrice: Const.RUN_UPLOAD_HELP2PAY_PRICE,
        _runTradingAccountList: Const.RUN_TRADING_ACCOUNT_LIST,
        _runClick2Call: Const.RUN_CLICK_2_CALL,
        _runClick2EndCall: Const.RUN_CLICK_2_ENDCALL,
        // Get Sub Ib List
        _runGetSubIbList: Const.RUN_GET_SUB_IB_LIST,
        //download commission list
        _runGetCommissionList: Const.RUN_GET_COMMISSION_LIST,
        _runDownloadCommissionList: Const.RUN_DOWNLOAD_COMMISSION_LIST_FILE,
        _runIbchangeList: Const.RUN_GET_IB_CHANGE_LIST,
        _runUpdateWithdrawalTxnid: Const.RUN_GET_UPDATE_WITHDRAWAL_TICKET_TXNID,
        _runInternalTicketList: Const.RUN_GET_INTERNAL_TICKET_LIST
    })), { redirect(getPageName, getId, getParams, getVerifiedStatus) {
            let inputJson = {
                name: getPageName,
                query: { 'id': getId }
            };
            if (getParams != '' && getParams != null && getParams != undefined) {
                inputJson.query['userId'] = getParams;
            }
            if (getVerifiedStatus != '' && getVerifiedStatus != null && getVerifiedStatus != undefined) {
                inputJson.query['getVerifiedStatus'] = getVerifiedStatus;
            }
            // this.$router.replace(inputJson)
            let routeData = this.$router.resolve(inputJson);
            window.open(routeData.href, '_blank');
        },
        getcourse(getid) {
            if (getid && this.tutorialCourse.length > 0) {
                let coursename = '-';
                this.tutorialCourse.forEach(value => {
                    if (getid == value._id) {
                        coursename = value.course;
                    }
                });
                return coursename;
            }
        },
        getcategory(getid) {
            if (getid && this.tutorialCat.length > 0) {
                let categoryname = '-';
                this.tutorialCat.forEach(value => {
                    if (getid == value._id) {
                        categoryname = value.category;
                    }
                });
                return categoryname;
            }
        },
        formatDecimal(getdata) {
            getdata = parseFloat(getdata).toFixed(2);
            return getdata;
        },
        handleValidationErrorAdvanced(getErrors) {
            const firstField = Object.keys(getErrors.collect())[0];
            this.$refs[`${firstField}Input`].focus();
            return this.$refs[`${firstField}Input`].scrollIntoView();
        },
        setData(getTitleName) {
            this.$parent.pageTitle = getTitleName;
            this.$parent.message = '';
            this.$parent.message_type = '';
        },
        computedCommonFunc(getFuncName) {
            try {
                return this.$store.getters[getFuncName];
            }
            catch (ex) {
                return [];
            }
        },
        permissionModule(getData, getpara, getData1) {
            let getDataSecondData = '';
            if (getData1 != '' && getData1 != null && getData1 != undefined) {
                getDataSecondData = getData1;
            }
            let perList = this.$store.getters[Types.GET_USER];
            perList = (perList.permissions || '').split(',');
            //return true ;
            if ((perList.indexOf(getData) >= 0) || (getDataSecondData != '' && perList.indexOf(getDataSecondData) >= 0)) {
                return true;
            }
            else if (getpara == 'view') {
                return false;
            }
            else {
                this.$router.replace({ name: 'noFound' });
            }
        },
        downloadSingleDocumentForZip(item) {
            return axios.get(item.url, { responseType: "blob" }).then((resp) => {
                zip.file(item.name, resp.data);
            });
        },
        downloadAllDocuments(fileArr) {
            const arrOfFiles = fileArr.map((item) => this.downloadSingleDocumentForZip(item)); //create array of promises
            Promise.all(arrOfFiles)
                .then(() => {
                console.log('arrOfFiles', arrOfFiles);
                zip.generateAsync({ type: "blob" }).then(function (blob) {
                    saveAs(blob, "all_documemts.zip");
                });
            })
                .catch((err) => {
                console.log(err);
            });
        },
        downloadSingleDocument(path, docName, extension) {
            axios
                .get(path, { responseType: 'blob' })
                .then(response => {
                saveAs(response.data, docName);
            });
        } }),
    computed: {
        //commission list
        getcommissionlist: function () { return this.computedCommonFunc(Const.GET_COMMISSION_LIST); },
        //client token
        commissionReportList: function () { return this.computedCommonFunc(Const.GET_COMMISSION_REPORT_LIST); },
        commissionWithdrawalList: function () { return this.computedCommonFunc(Const.GET_COMMISSION_WITHDRAWAL_LIST); },
        commissionReportDetail: function () { return this.computedCommonFunc(Const.GET_COMMISSION_REPORT_DETAIL); },
        transactionList: function () { return this.computedCommonFunc(Const.GET_LOYALITY_TRANSACTION_LIST); },
        cardList: function () { return this.computedCommonFunc(Const.GET_LOYALITY_CARD_LIST); },
        getClientData: function () { return this.computedCommonFunc(Const.GET_CLIENT_DATA); },
        vpsList: function () { return this.computedCommonFunc(Const.GET_VPS_LIST); },
        subscriptionList: function () { return this.computedCommonFunc(Const.GET_SUBSCRIPTION_LIST); },
        subscriptionDetail: function () { return this.computedCommonFunc(Const.GET_SUBSCRIPTION_DETAIL); },
        userOtherDetail: function () { return this.computedCommonFunc(Const.GET_USER_OTHER_DETAILS); },
        countriesList: function () { return this.computedCommonFunc(Const.GET_COUNTRIES_LIST); },
        citiesList: function () { return this.computedCommonFunc(Const.GET_CITIES_LIST); },
        /*IbUserDocsLink : function(){ return this.computedCommonFunc(Const.GET_IB_USER_DOCUMENT_LINK); },
        IbTicketDocsLink : function(){ return this.computedCommonFunc(Const.GET_IB_TICKET_DOCUMENT_LINK); },*/
        IbUserDocsLink: function () { return process.env.IbUserDocsLink; },
        IbTicketDocsLink: function () { return process.env.IbticketDocsLink; },
        //coupon
        couponList: function () { return this.computedCommonFunc(Const.GET_COUPON_LIST); },
        //notification list
        notificationList: function () { return this.computedCommonFunc(Const.GET_ALL_NOTIFICATION_LIST); },
        notificationListOld: function () { return this.computedCommonFunc(Const.GET_NOTIFICATION_OLD_LIST); },
        notificationUnreadList: function () { return this.computedCommonFunc(Const.GET_UNREAD_NOTIFICATION_LIST); },
        //admin
        adminList: function () { return this.computedCommonFunc(Const.GET_ADMIN_LIST); },
        adminDetail: function () { return this.computedCommonFunc(Const.GET_ADMIN_DETAIL); },
        groupAdminName: function () { return this.computedCommonFunc(Const.GET_GROUP_ADMIN_NAME); },
        userGroupId: function () { return this.computedCommonFunc(Const.GET_USER_GROUP_ID); },
        //email
        emailList: function () { return this.computedCommonFunc(Const.GET_EMAIL_SETTING_LIST); },
        //ib
        IbList: function () { return this.computedCommonFunc(Const.GET_IB_LIST); },
        IbView: function () { return this.computedCommonFunc(Const.GET_IB_VIEW); },
        ibchangelist: function () { return this.computedCommonFunc(Const.GET_IB_CHANGE_LIST); },
        //Sub Ib List
        subiblist: function () { return this.computedCommonFunc(Const.GET_SUB_IB_LIST); },
        //client
        get_user: function () { return this.computedCommonFunc(Types.GET_USER); },
        emailData: function () { return this.computedCommonFunc(Const.GET_EMAIL_DATA); },
        withdrawalMethodResponse: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_METHOD_RESPONSE); },
        userList: function () { return this.computedCommonFunc(Const.GET_USER_LIST); },
        logsList: function () { return this.computedCommonFunc(Const.GET_LOGS_LIST); },
        logsView: function () { return this.computedCommonFunc(Const.GET_LOGS_VIEW); },
        userView: function () { return this.computedCommonFunc(Const.GET_USER_VIEW); },
        userCount: function () { return this.computedCommonFunc(Const.GET_USER_COUNT); },
        riskMetrix: function () { return this.computedCommonFunc(Const.GET_RISK_METRIX); },
        articleList: function () { return this.computedCommonFunc(Const.GET_ARTICLE_LIST); },
        catList: function () { return this.computedCommonFunc(Const.GET_CAT_LIST); },
        genderList: function () { return this.computedCommonFunc(Const.GET_GENDER_LIST); },
        internalNotesList: function () { return this.computedCommonFunc(Const.GET_INTERNAL_NOTES); },
        deptMethdList: function () { return this.computedCommonFunc(Const.GET_DEPT_METHD); },
        stepList: function () { return this.computedCommonFunc(Const.GET_STEP); },
        timeZone: function () { return this.computedCommonFunc(Const.GET_TIMEZONE); },
        //deposit
        depositList: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_LIST); },
        depositView: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_VIEW); },
        depositStatus: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_STATUS); },
        depositMethod: function () { return this.computedCommonFunc(Const.GET_DEPOSIT_METHOD); },
        bankOpions: function () { return this.computedCommonFunc(Const.GET_BANK_OPTIONS); },
        //bonus
        bonusList: function () { return this.computedCommonFunc(Const.GET_BONUS_LIST); },
        bonusView: function () { return this.computedCommonFunc(Const.GET_BONUS_VIEW); },
        //ticket
        ticketList: function () { return this.computedCommonFunc(Const.GET_TICKET_LIST); },
        ticketView: function () { return this.computedCommonFunc(Const.GET_TICKET_VIEW); },
        ticketDocs: function () { return this.computedCommonFunc(Const.GET_TICKET_DOCS); },
        ticketDocsLink: function () { return this.computedCommonFunc(Const.GET_TICKET_DOCS_LINK); },
        ticket_reply_pre: function () { return this.computedCommonFunc(Const.GET_TICKET_REPLY_PRE); },
        //zip
        getzipdoclink: function () { return this.computedCommonFunc(Const.GET_ZIP_DOCS_LINK); },
        ticketStatus: function () { return this.computedCommonFunc(Const.GET_TICKET_STATUS); },
        ticketReason: function () { return this.computedCommonFunc(Const.GET_TICKET_REASON); },
        departmentList: function () { return this.computedCommonFunc(Const.GET_DEPARMENT_LIST); },
        language_list: function () { return this.computedCommonFunc(Const.GET_LANGUAGE_LIST); },
        internalReasonList: function () { return this.computedCommonFunc(Const.GET_INTERNAL_TICKET_REASON); },
        ticketReasonList: function () { return this.computedCommonFunc(Const.GET_TICKET_REASON_LIST); },
        ticketReasonList1: function () { return this.computedCommonFunc(Const.GET_TICKET_REASON_LIST1); },
        ticketData: function () { return this.computedCommonFunc(Const.GET_TICKET_DATA); },
        //withdrawal
        withdrawalList: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_LIST); },
        withdrawalListMaker: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_LIST_MAKER); },
        withdrawalView: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_VIEW); },
        withdrawalType: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_TYPE); },
        withdrawalMethods: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_METHODS); },
        withdrawalMethod: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_METHOD); },
        withdrawalStatus: function () { return this.computedCommonFunc(Const.GET_WITHDRAWAL_STATUS); },
        //trading
        tradingList: function () { return this.computedCommonFunc(Const.GET_TRADING_LIST); },
        tradingView: function () { return this.computedCommonFunc(Const.GET_TRADING_VIEW); },
        demoLive: function () { return this.computedCommonFunc(Const.GET_DEMO_LIVE); },
        currency: function () { return this.computedCommonFunc(Const.GET_CURRENCY); },
        //bonus
        bonusType: function () { return this.computedCommonFunc(Const.GET_BONUS_TYPE); },
        bonusStatus: function () { return this.computedCommonFunc(Const.GET_BONUS_STATUS); },
        //tutorials
        tutorialCourse: function () { return this.computedCommonFunc(Const.GET_TUT_COURSE); },
        tutorialCat: function () { return this.computedCommonFunc(Const.GET_TUT_CAT); },
        tutorialList: function () { return this.computedCommonFunc(Const.GET_TUTORIAL_LIST); },
        //tradingeducation
        categoryList: function () { return this.computedCommonFunc(Const.GET_CATEGORY_LIST); },
        postList: function () { return this.computedCommonFunc(Const.GET_POST_LIST); },
        uploadsList: function () { return this.computedCommonFunc(Const.GET_UPLOADS_LIST); },
        clientLeads: function () { return this.computedCommonFunc(Const.GET_CLIENT_LEADS); },
        depositMethods: function () { return this.computedCommonFunc(Const.GET_ADMIN_DEPOSIT_METHODS); },
        loyalityCount: function () { return this.computedCommonFunc(Const.GET_LOYALITY_POINT_COUNT); },
    },
    // filters: {
    // 	moment: function (date) {
    //     return moment(date).local().format('Do, MMM YYYY hh:mm a');
    //   }   
    // }
};



//////////////////
// WEBPACK FOOTER
// ./src/plugins/fxView/index.ts
// module id = null
// module chunks = 